export default {
  reward_title: "Einladungsbelohnungen",
  reward_desc_dynamic:
    "Für jeden Freund, den Sie erfolgreich zur Registrierung einladen, erhalten Sie {0} Berechnungsguthaben als Belohnung",
  invite_friend: "Freunde einladen",
  friend_email: "E-Mail des Freundes",
  email_placeholder: "Bitte geben Sie die E-Mail Ihres Freundes ein",
  send_invite: "Einladung senden",
  invite_instructions: "Einladungsanweisungen",
  email_invitation_validity_dynamic: "E-Mail-Einladungen sind {0} Tage lang gültig",
  link_invitation_permanent: "Link-Einladungen sind dauerhaft gültig",
  instruction_1_dynamic:
    "Für jede erfolgreiche Einladung erhalten Sie und Ihr Freund jeweils {0} Berechnungsguthaben",
  instruction_2:
    "Belohnungen werden automatisch gutgeschrieben, nachdem Ihr Freund die Einladung akzeptiert und sich erfolgreich registriert hat",
  instruction_3:
    "Belohnungsguthaben kann für Kohlenstoffemissionsberechnungen verwendet werden und ist gemäß Ihrem Abonnementplan gültig",
  invite_stats: "Einladungsstatistik",
  total_invites: "Einladungen insgesamt",
  accepted_invites: "Akzeptierte Einladungen",
  reward_credits: "Belohnungsguthaben",
  invite_link: "Persönlicher Einladungslink",
  reward_rules: "Belohnungsregeln",
  reward_rule_1_dynamic:
    "Für jede erfolgreiche Einladung erhalten Sie {0} Berechnungsguthaben als Belohnung",
  reward_rule_2:
    "Belohnungsguthaben wird automatisch Ihrem Konto gutgeschrieben und kann für Kohlenstoffemissionsberechnungen verwendet werden",
  reward_rule_3:
    "Bei Erkennung von Betrug behalten wir uns das Recht vor, Belohnungen zu stornieren und das Konto zu sperren",
  email_required: "Bitte geben Sie eine E-Mail-Adresse ein",
  email_invalid: "Ungültiges E-Mail-Format",
  invite_sent: "Einladung gesendet",
  send_failed: "Senden der Einladung fehlgeschlagen",
  fetch_failed: "Einladungsinformationen konnten nicht abgerufen werden",
  copy_success: "Erfolgreich kopiert",
  email_invitation: "E-Mail-Einladung",
  link_invitation: "Link-Einladung",
  status_pending: "Ausstehend",
  status_accepted: "Akzeptiert",
  status_expired: "Abgelaufen",
  reward_issued: "Ausgestellt",
  pending: "Ausstehend",
  reward_pending_tip:
    "Belohnungen werden gutgeschrieben, nachdem Ihr Freund seine erste Berechnung durchgeführt hat",
  expiring_soon: "Läuft bald ab",
  no_invitations: "Keine Einladungsdatensätze",
  invitee_id: "Eingeladener ID",
  type: "Einladungstyp",
  email: "E-Mail",
  status: "Status",
  reward_status: "Belohnungsstatus",
  invite_time: "Einladungszeit",
  expire_time: "Ablaufdatum",
  my_invitations: "Meine Einladungen",
  invite_created_title: "Einladungslink",
  invite_created_desc:
    "E-Mail konnte nicht gesendet werden. Bitte senden Sie den folgenden Link manuell an Ihren Freund:",
  total_invitations: "Insgesamt {0} Datensätze",
  search_invitations: "Einladungen suchen...",
  confirm: "Bestätigen",
};
